import useFeatureFlag, { FEATURE_FLAGS } from '@/utils/featureFlags';

export const useIsLockCardPurseAvailable = (): boolean =>
  useFeatureFlag(FEATURE_FLAGS.LOCK_CARD_PURSE);
